document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.tooltip').forEach(tooltip => {
    const tooltipText = tooltip.querySelector('.tooltiptext');

    tooltip.addEventListener('mouseenter', () => {
      const rect = tooltipText.getBoundingClientRect();
      const offset = 10;

      if (rect.right > window.innerWidth) {
        tooltipText.style.left = 'auto';
        tooltipText.style.right = `${offset}px`;
        tooltipText.style.transform = 'none';
      }

      if (rect.left < 0) {
        tooltipText.style.left = `${offset}px`;
        tooltipText.style.right = 'auto';
        tooltipText.style.transform = 'none';
      }

      if (rect.top < 0) {
        tooltipText.style.bottom = 'auto';
        tooltipText.style.top = `${offset}px`;
      }
    });

    tooltip.addEventListener('mouseleave', () => {
      tooltipText.style.left = '';
      tooltipText.style.right = '';
      tooltipText.style.bottom = '';
      tooltipText.style.top = '';
      tooltipText.style.transform = 'translateX(-50%)';
    });
  });
});

document.querySelectorAll('.tooltip').forEach(tooltip => {
  tooltip.addEventListener('mouseenter', () => {
    const tooltipText = tooltip.querySelector('.tooltiptext');
    const rect = tooltipText.getBoundingClientRect();

    if (rect.top < 0) {
      tooltipText.style.top = '10px'; // Adjust as needed
    }
    if (rect.bottom > window.innerHeight) {
      tooltipText.style.top = `${window.innerHeight - rect.height - 10}px`;
    }
    if (rect.left < 0) {
      tooltipText.style.left = '10px';
    }
    if (rect.right > window.innerWidth) {
      tooltipText.style.left = `${window.innerWidth - rect.width - 10}px`;
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const closeButtons = document.querySelectorAll(".close-button");

  closeButtons.forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation(); // Prevents accidental clicks on swatches behind
      const tooltip = btn.closest(".variant-tooltip");
      if (tooltip) tooltip.style.display = "none";
    });
  });
});

document.querySelectorAll('.option-selector').forEach(function (el) {
  el.addEventListener('click', function () {
    const input = el.querySelector('input[type="radio"], input[type="checkbox"]');
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true })); // trigger Shopify's update logic
    }
  });
});

